import { render } from "./PartnerProgram.vue?vue&type=template&id=6c5f17a2&scoped=true"
import script from "./PartnerProgram.vue?vue&type=script&lang=js"
export * from "./PartnerProgram.vue?vue&type=script&lang=js"

import "./PartnerProgram.vue?vue&type=style&index=0&id=6c5f17a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5f17a2"]])

export default __exports__